import { CommonModule, DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, DestroyRef, effect, inject, Renderer2, signal } from '@angular/core';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { ApplicationStateFacade } from 'mbs-ui-shared@facades/application.facade';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';

@Component({
  selector: 'mbs-footer',
  templateUrl: './app-footer.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class AppFooterComponent {
  private auth = inject(AuthFacade);
  private document = inject<Document>(DOCUMENT);
  private applicationStateFacade = inject(ApplicationStateFacade);
  private destroyRef = inject(DestroyRef);
  private renderer = inject(Renderer2);

  protected defaultFooterLogoImage = 'assets/Logo_main_tag.svg';

  protected rebrandingActivated = signal(false);
  protected footerLogoImage = signal('');
  protected isShowFooter = computed(() => !this.rebrandingActivated() || (this.rebrandingActivated() && !!this.footerLogoImage()));
  protected currentDate = Date.now();

  constructor() {
    effect(() => {
      this.renderer[this.isShowFooter() ? 'addClass' : 'removeClass'](this.document.body, '-showFooter');
    });

    this.destroyRef.onDestroy(() => {
      this.renderer.removeClass(this.document.body, '-showFooter');
      this.applicationStateFacade.setFooterExist(false);
    });

    toObservable(this.isShowFooter)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isShow) => this.applicationStateFacade.setFooterExist(isShow));

    this.auth.brandingSetting$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      this.rebrandingActivated.set(data?.BrandingActivated || false);
      this.footerLogoImage.set(data?.BrandingActivated && data?.FooterLogoImageUrl ? data.FooterLogoImageUrl : this.defaultFooterLogoImage);
    });
  }
}
